module.exports = "/_next/static/images/btctestnet-2fde9136f44b10e064cef4a9070c48e6.svg";